import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DeleteModal from "../../components/Common/DeleteModal";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError, toBase64Url } from "../../utils";
import {
    isActiveEnrollmentProgram,
    parentHasActiveChildEnrollment,
    parentHasCompletedPastCohort,
    filterParentsByCohortMode,
} from "../../utils/enrollmentFilters";
import withAuth from "../withAuth";
import { baseUrl } from "../../Network";
import { Badge, Col, Collapse, Container, Form, Input, Label, Modal, ModalBody, ModalHeader, ModalFooter, Row, } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    BtnBold,
    BtnItalic,
    Editor,
    EditorProvider,
    Toolbar,
    BtnLink,
    BtnBulletList,
    BtnClearFormatting,
    BtnNumberedList,
    BtnStyles,
    BtnUndo,
    BtnRedo,
    BtnStrikeThrough,
    BtnUnderline
} from "react-simple-wysiwyg";
import UploadWidget from "../../Uploader";
import currency_country from "../../constants/currency_countries.json";
import { newFormatDate } from "../../utils";
import PaginationControls from "../../components/Common/PaginationControls";
import ActionsDropdown from "../../components/Common/ActionsDropdown";
import ActivateAiTransferModal from "../../components/Common/ActivateAiTransferModal";
import StatusBadge from "../../components/Common/StatusBadge";
import { useConfirm } from "../../contexts/ConfirmContext";
import countriesData from "../Custom/countries.json";
import { isMarketerReadOnly } from "../../helpers/adminRole";

const FilterField = ({ label, children }) => (
    <label className="parent-filter-field">
        <span>{label}</span>
        {children}
    </label>
);

const ManageParent = () => {
    const location = useLocation();
    const isAiParentPage = location.pathname === "/manage-ai-parent" || location.pathname === "/ai/parents";
    const readOnly = isMarketerReadOnly();
    const { showConfirm } = useConfirm();
    const [usersRaw, setUsersRaw] = useState([]);
    const [usersRawF, setUsersRawF] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [contact, setContact] = useState({});
    const [modal, setModal] = useState(false);
    const [modalk, setModalk] = useState(false);
    const [freeCohort, setFreeCohort] = useState(false);
    const [modalSingle, setModalSingle] = useState(false);
    const [updateParentModal, setUpdateParentModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [country, setCountry] = useState([]);
    const [state, setState] = useState([]);
    const [timezone, setTimezone] = useState([]);
    const [privateParentOnly, setPrivateParentOnly] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [groupEmailData, SetGroupEmailData] = useState({ t: 0, s: "", b: "" });
    const [url, updateUrl] = useState(null);
    const [error, updateError] = useState();
    const [balKey, setBalanceKey] = useState({});
    const [balKeyEdit, setBalKeyEdit] = useState({});
    const [noteModal, setNoteModal] = useState(false);
    const [referedModal, setReferedModal] = useState(false);
    const [selectedParent, setSelectedParent] = useState(null);
    const [parentNotes, setParentNotes] = useState([]);
    const [newNote, setNewNote] = useState("");
    const [multiIDs, setMultiIDs] = useState([]);
    const [multiTargetIDs, setMultiTargetIDs] = useState({});
    const [assignModal, setAssignModal] = useState(false);
    const [secondary, setSecondary] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [referedParents, setReferedParents] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [actionLoadingId, setActionLoadingId] = useState(null);
    const [activateTransferModal, setActivateTransferModal] = useState(false);
    const [activateTransferParent, setActivateTransferParent] = useState(null);
    const [updateParentForm, setUpdateParentForm] = useState({
        id: null,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        timezone: "",
    });
    const [updatingParent, setUpdatingParent] = useState(false);

    const normalizePhoneWithCountryCode = (rawPhone, phoneCode) => {
        const source = String(rawPhone || "").trim();
        if (!phoneCode) return source;

        const selectedCode = String(phoneCode).replace(/\D/g, "");
        const digitsOnly = source.replace(/\D/g, "");

        if (!digitsOnly) return `+${selectedCode}`;

        let localPart = digitsOnly;
        if (digitsOnly.startsWith(selectedCode)) {
            localPart = digitsOnly.slice(selectedCode.length);
        }

        if (!localPart) return `+${selectedCode}`;
        return `+${selectedCode} ${localPart}`;
    };

    /** AI Tutor abandon drip flags already stored on the parent row. */
    const getAiAbandonEmailsSent = (parent) => {
        const sent = [];
        if (parent?.aiEnrollAbandonEmail24hSent) sent.push("Enroll 24h");
        if (parent?.aiEnrollAbandonEmail5dSent) sent.push("Enroll 5d");
        if (parent?.aiClickAbandonEmail24hSent) sent.push("Click 24h");
        return sent;
    };
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 20,
        hasNextPage: false,
        hasPreviousPage: false
    });
    const [showAll, setShowAll] = useState(false);
    const [assignedAdminFilter, setAssignedAdminFilter] = useState("");
    const [pastCompletedFilter, setPastCompletedFilter] = useState("");
    const [activeChildFilter, setActiveChildFilter] = useState("");
    const [aiAccessFilter, setAiAccessFilter] = useState("");
    const [subscriptionStatusFilter, setSubscriptionStatusFilter] = useState("");
    const [countryFilter, setCountryFilter] = useState("");
    const [stateFilter, setStateFilter] = useState("");
    const [leadSourceFilter, setLeadSourceFilter] = useState("");
    const [activeCohortFilter, setActiveCohortFilter] = useState("");
    const [previouslySubscribedFilter, setPreviouslySubscribedFilter] = useState("");
    const [dndFilter, setDndFilter] = useState("");
    const [smsOptOutFilter, setSmsOptOutFilter] = useState("");
    const [emailOptOutFilter, setEmailOptOutFilter] = useState("");
    const [filterMeta, setFilterMeta] = useState({ countries: [], leadSources: [], activeCohorts: [] });
    const [filterResetKey, setFilterResetKey] = useState(0);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [listNonce, setListNonce] = useState(0);

    // Add this function to fetch all admins
    const fetchAdmins = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/all`);
            setAdmins(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching admins:", error);
            toast.error("Failed to fetch admins");
        }
    };

    // Add this function to handle parent assignment
    const handleAssignParent = async () => {
        if (!selectedAdmin) {
            toast.error("Please select an admin");
            return;
        }

        try {
            const parentIds = multiIDs.length > 0 ? multiIDs : [selectedParent?.id];
            const url = secondary ? `${baseUrl}/admin/parent/secondary/assigned` : `${baseUrl}/admin/parent/assigned`
            await axios.post(url, {
                adminId: selectedAdmin,
                parentIds
            });

            toast.success(`Parent(s) assigned successfully`);
            setAssignModal(false);
            setSecondary(false)
            setSelectedAdmin(null);
            setMultiIDs([]); // Clear selection after assignment
            fetchUsers()
        } catch (error) {
            handleAuthError(error)
            console.error("Error assigning parent:", error);
            toast.error("Failed to assign parent(s)");
        }
    };

    // Add this function to toggle the assign modal
    const toggleAssignModal = (parent = null) => {
        setSelectedParent(parent);
        if (!admins.length) {
            fetchAdmins();
        }
        setAssignModal(!assignModal);
    };

    // Add this function to fetch parent notes
    const fetchParentNotes = async (parentId) => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/note/${parentId}`);
            setParentNotes(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching notes:", error);
            toast.error("Failed to fetch notes");
        }
    };

    const fetchParentRefered = async (parentId) => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/refered/${parentId}`);
            setReferedParents(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching notes:", error);
            toast.error("Failed to fetch refered parents");
        }
    };

    // Add this function to handle adding a new note
    const handleAddNote = async () => {
        if (!newNote.trim()) {
            toast.error("Note cannot be empty");
            return;
        }

        try {
            await axios.post(`${baseUrl}/admin/parent/note`, {
                parentId: selectedParent.id,
                note: newNote
            });
            toast.success("Note added successfully");
            fetchParentNotes(selectedParent.id);
            toggleNoteModal();
            setNewNote("");
        } catch (error) {
            handleAuthError(error)
            toast.error("Failed to add note");
        }
    };

    const handleFreeCohort = async () => {
        if (!Number(freeCohort)) {
            toast.error("Input cannot be empty");
            return;
        }
        toast.warning("Processing.......");
        try {
            await axios.put(`${baseUrl}/admin/parent/freechohort/${selectedParent.id}`, {
                freeCohort
            });
            toast.success("Free cohort allocated successfully");
            togglek();
            setFreeCohort("");
            fetchUsers()
        } catch (error) {
            handleAuthError(error)
            console.log(error)
            toast.error("Failed to assign free cohort");
        }
    };

    // Add this function to toggle the note modal
    const toggleNoteModal = (parent = null) => {
        setParentNotes([])
        setSelectedParent(parent);
        if (parent) {
            fetchParentNotes(parent.id);
        }
        setNoteModal(!noteModal);
    };

    const toggleParentsModal = (parent = null) => {
        setReferedParents([])
        setSelectedParent(parent);
        if (parent) {
            fetchParentRefered(parent.id);
        }
        setReferedModal(!referedModal);
    };

    useEffect(() => {
        document.title = `${isAiParentPage ? "AI Tutor Parents" : "Parents"} | RYD Admin`;
        fetchUsers().then(null);
    }, [
        modal, currentPage, pageSize, searchQuery, isAiParentPage, listNonce,
        aiAccessFilter, subscriptionStatusFilter, countryFilter, stateFilter,
        leadSourceFilter, pastCompletedFilter, activeChildFilter, activeCohortFilter,
        assignedAdminFilter, previouslySubscribedFilter, dndFilter, smsOptOutFilter,
        emailOptOutFilter,
    ]);

    useEffect(() => {
        if (!isAiParentPage) {
            fetchAdmins();
        }
    }, [isAiParentPage]);

    useEffect(() => {
        let cancelled = false;
        axios.get(`${baseUrl}/admin/parent/filter-meta`, {
            params: { audience: isAiParentPage ? "ai" : "normal" },
        }).then((response) => {
            if (cancelled) return;
            const data = response?.data?.data || {};
            setFilterMeta({
                countries: Array.isArray(data.countries) ? data.countries : [],
                leadSources: Array.isArray(data.leadSources) ? data.leadSources : [],
                activeCohorts: Array.isArray(data.activeCohorts) ? data.activeCohorts : [],
            });
        }).catch((error) => {
            handleAuthError(error);
        });
        return () => {
            cancelled = true;
        };
    }, [isAiParentPage]);

    useEffect(() => {
        const countries = Array.isArray(countriesData) ? countriesData : [];
        const normalizedCountries = countries
            .map((item) => ({
                name: item?.name || "",
                phone_code: item?.phone_code || "",
                states: Array.isArray(item?.states) ? item.states : [],
                timezones: Array.isArray(item?.timezones) ? item.timezones : [],
            }))
            .filter((item) => item.name)
            .sort((a, b) => String(a.name).localeCompare(String(b.name)));
        setCountry(normalizedCountries);
    }, []);

    function handleOnUpload(error, result, widget) {
        if (error) {
            updateError(error);
            widget.close({
                quiet: true
            });
            return;
        }
        updateUrl(result?.info?.secure_url);
    }

    const applyAssignedAdminFilter = (list, selectedAdminId = assignedAdminFilter) => {
        if (!selectedAdminId) return list || [];
        if (selectedAdminId === "unassigned") {
            return (list || []).filter((parent) => !parent?.assignedTo);
        }
        return (list || []).filter((parent) => String(parent?.assignedTo || parent?.admin?.id || "") === String(selectedAdminId));
    };

    const getParentProgramInsights = (parent) => {
        const children = Array.isArray(parent?.children) ? parent.children : [];
        const programsByChild = children.map((child) => ({
            child,
            programs: Array.isArray(child?.programs) ? child.programs : [],
        }));

        const hasCompletedPastCohort = parentHasCompletedPastCohort(parent);
        // Active = paid program on an Ongoing cohort (cohort.isStarted)
        const hasActiveChildEnrollment = parentHasActiveChildEnrollment(parent);

        const childLevelSummary = programsByChild.map(({ child, programs }) => {
            const sortedPrograms = [...programs].sort(
                (a, b) => (Number(b?.id) || 0) - (Number(a?.id) || 0)
            );
            const currentProgram = sortedPrograms.find((program) => program?.isPaid === true);
            if (!currentProgram) return "-";

            const levelNumber = currentProgram?.package?.level ?? child?.level ?? "-";
            const packageTitle = String(currentProgram?.package?.title || "")
                .replace(/program/gi, "")
                .trim();
            if (!packageTitle) return `Level ${levelNumber}`;
            return `${packageTitle} level ${levelNumber}`;
        }).join(" | ");

        return {
            hasCompletedPastCohort,
            hasActiveChildEnrollment,
            childLevelSummary: childLevelSummary || "-",
        };
    };

    const applyParentTableFilters = (
        list,
        adminFilter = assignedAdminFilter,
        pastFilter = pastCompletedFilter,
        activeFilter = activeChildFilter
    ) => {
        const base = list || [];
        const byProgramFlags = base.filter((parent) => {
            const insights = getParentProgramInsights(parent);
            const matchPast =
                !pastFilter ||
                (pastFilter === "yes" ? insights.hasCompletedPastCohort : !insights.hasCompletedPastCohort);
            const matchActive =
                !activeFilter ||
                (activeFilter === "yes" ? insights.hasActiveChildEnrollment : !insights.hasActiveChildEnrollment);
            return matchPast && matchActive;
        });

        return applyAssignedAdminFilter(byProgramFlags, adminFilter);
    };

    const fetchUsers = async (forceNoSearch = false, filterOverrides = {}) => {
        try {
            setLoading(true);
            const limit = showAll ? 10000 : pageSize;
            const accessFilter =
                filterOverrides.aiAccessFilter !== undefined
                    ? filterOverrides.aiAccessFilter
                    : aiAccessFilter;
            const subFilter =
                filterOverrides.subscriptionStatusFilter !== undefined
                    ? filterOverrides.subscriptionStatusFilter
                    : subscriptionStatusFilter;
            const params = {
                page: currentPage,
                limit: limit,
                audience: isAiParentPage ? "ai" : "normal",
                ...(!forceNoSearch && searchQuery && { search: searchQuery }),
                ...(accessFilter && { canAccessAi: accessFilter }),
                ...(subFilter && { isSubscribed: subFilter }),
                ...(countryFilter && { country: countryFilter }),
                ...(stateFilter && { state: stateFilter }),
                ...(leadSourceFilter && { leadSource: leadSourceFilter }),
                ...(pastCompletedFilter && { pastCohort: pastCompletedFilter }),
                ...(activeChildFilter && { activeChild: activeChildFilter }),
                ...(activeCohortFilter && { activeCohortId: activeCohortFilter }),
                ...(assignedAdminFilter && { assignedAdmin: assignedAdminFilter }),
                ...(previouslySubscribedFilter && { previouslySubscribed: previouslySubscribedFilter }),
                ...(dndFilter && { dnd: dndFilter }),
                ...(smsOptOutFilter && { smsOptOut: smsOptOutFilter }),
                ...(emailOptOutFilter && { emailOptOut: emailOptOutFilter }),
            };
            const response = await axios.get(`${baseUrl}/admin/parent/all`, { params });
            const responseData = response.data.data;
            // Handle new response structure with data and pagination
            const data = responseData?.data || (Array.isArray(responseData) ? responseData : []);
            const paginationData = responseData?.pagination || {
                currentPage: 1,
                totalPages: 1,
                totalItems: Array.isArray(data) ? data.length : 0,
                itemsPerPage: limit,
                hasNextPage: false,
                hasPreviousPage: false
            };
            const normalizedData = Array.isArray(data) ? data : [];
            setUsersRaw(normalizedData);
            setUsersRawF(normalizedData);
            setUsers(normalizedData);
            setPagination(paginationData);
            setLoading(false);
        } catch (error) {
            handleAuthError(error)
            setLoading(false);
            console.error("Error:", error);
            const st = error.response?.status;
            if (st && st !== 401 && st !== 403) {
                toast.error(
                    error.response?.data?.message || error.message || "Failed to load parents"
                );
            }
        }
    };

    /** Manage AI parents (`/ai/parents`): cancel this row's Stripe AI subscription via admin API */
    const adminCancelAiParentSubscription = async (user, immediate) => {
        if (!user?.id) return;
        setActionLoadingId(user.id);
        try {
            const r = await axios.post(`${baseUrl}/admin/subscription/cancel/${user.id}`, { immediate });
            if (r.data?.status) {
                toast.success(
                    r.data.message ||
                        (immediate ? "Subscription cancelled" : "Cancellation scheduled at period end")
                );
                await fetchUsers(true);
            } else {
                toast.error(r.data?.message || "Failed");
            }
        } catch (e) {
            handleAuthError(e);
            toast.error(e.response?.data?.message || e.message || "Failed");
        } finally {
            setActionLoadingId(null);
        }
    };

    const openActivateTransferModal = (user) => {
        setActivateTransferParent(user || null);
        setActivateTransferModal(true);
    };

    const activateAiByTransfer = async (duration) => {
        if (!activateTransferParent?.id) return;
        setActionLoadingId(activateTransferParent.id);
        try {
            const payload =
                duration?.days != null
                    ? { days: Number(duration.days) }
                    : { months: Number(duration?.months ?? duration) };
            const r = await axios.post(
                `${baseUrl}/admin/subscription/activate-transfer/${activateTransferParent.id}`,
                payload
            );
            if (r.data?.status) {
                toast.success(r.data.message || "AI access activated");
                setActivateTransferModal(false);
                setActivateTransferParent(null);
                await fetchUsers(true);
            } else {
                toast.error(r.data?.message || "Failed");
            }
        } catch (e) {
            handleAuthError(e);
            toast.error(e.response?.data?.message || e.message || "Failed");
        } finally {
            setActionLoadingId(null);
        }
    };

    const toggle = () => {
        setModal(!modal);
    };
    const togglek = () => {
        setModalk(!modalk);
        setFreeCohort("")
    };

    const toggleSingle = () => {
        setModalSingle(!modalSingle);
    };
    const toggleUpdateParentModal = () => {
        setUpdateParentModal(!updateParentModal);
    };

    const handleUserClick = (userData) => {
        setContact(userData);
        setIsEdit(true);
        toggle();
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            subject: "",
            message: "",
        },
        validationSchema: Yup.object({
            subject: Yup.string().required("Please enter the subject"),
            message: Yup.string().required("Please enter the message"),
        }),
    });

    const handleSendEmailAll = async (event) => {
        event.preventDefault();
        try {
            await axios.post(`${baseUrl}/admin/parent/send/all`, {
                ...groupEmailData,
                ...(url ? { attachmentLink: url } : {}),
            });
            toast.success("Email sent to all parents successfully");
            toggle();
        } catch (error) {
            handleAuthError(error)
            toast.error("Failed to send email to parents");
        }
    };

    const handleSendEmailSingle = async (event) => {
        event.preventDefault();
        try {
            const payload = {
                body: validation.values.message,
                subject: validation.values.subject,
            };
            if (url) payload.attachmentLink = url;
            const response = await axios.post(`${baseUrl}/admin/parent/send/${selectedUserId}`, payload);
            if (response.data?.status) {
                toast.success("Email sent to the parent successfully");
                toggleSingle();
            } else {
                toast.error(response.data?.message || "Failed to send email to the parent");
            }
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
            toast.error(error.response?.data?.message || "Failed to send email to the parent");
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const applyServerFilter = (setter) => (value) => {
        setter(value);
        setCurrentPage(1);
    };

    const handleCountryFilter = (value) => {
        setCountryFilter(value);
        setStateFilter("");
        setCurrentPage(1);
    };

    const handleAiAccessFilter = applyServerFilter(setAiAccessFilter);
    const handleSubscriptionStatusFilter = applyServerFilter(setSubscriptionStatusFilter);

    const exportCurrentParents = () => {
        if (!Array.isArray(users) || users.length === 0) {
            toast.warn("No parent data available to export");
            return;
        }

        const csvEscape = (value) => {
            const stringValue = value === null || value === undefined ? "" : String(value);
            return `"${stringValue.replace(/"/g, '""')}"`;
        };

        const rows = users.map((parent) => {
            const childNames = Array.isArray(parent?.children)
                ? parent.children.map((child) => `${child?.firstName || ""} ${child?.lastName || ""}`.trim()).join(" | ")
                : "";
            const assignedTo = parent?.assignedTo ? (parent?.admin?.fullName || parent?.assignedTo) : "Unassigned";
            return [
                parent?.id,
                `${parent?.firstName || ""} ${parent?.lastName || ""}`.trim(),
                childNames,
                parent?.email || "",
                parent?.phone || "",
                parent?.state || "",
                parent?.survey || "",
                parent?.country || "",
                parent?.timezone || "",
                assignedTo,
                parent?.dnd === 1 ? "ON" : "OFF",
                parent?.smsOptOut ? "Yes" : "No",
                parent?.emailOptOut ? "Yes" : "No",
                parent?.canAccessAi ? "Yes" : "No",
                parent?.isSubscribed ? "Active" : "Inactive",
                parent?.aiSubscribedAt ? newFormatDate(parent.aiSubscribedAt) : "",
                ...(isAiParentPage
                    ? [
                        parent?.aiCanceledAt ? newFormatDate(parent.aiCanceledAt) : "",
                        parent?.previouslySubscribedToAi ? "Yes" : "No",
                    ]
                    : []),
                getAiAbandonEmailsSent(parent).join(" | ") || "None",
                parent?.referredBy ? "YES" : "NO",
                parent?.totalReferred || 0,
                newFormatDate(parent?.createdAt),
            ].map(csvEscape).join(",");
        });

        const headers = [
            "Parent ID",
            "Parent Name",
            "Children",
            "Email",
            "Phone",
            "State",
            "Lead Source",
            "Country",
            "Timezone",
            "Assigned To",
            "DND",
            "SMS Opt-Out",
            "Email Opt-Out",
            "AI access",
            "Subscription status",
            "Subscribed date",
            ...(isAiParentPage
                ? ["Subscription cancellation date", "Previously subscribed to AI"]
                : []),
            "Emails sent",
            "Referred",
            "Total Referred",
            "Created At",
        ].join(",");

        const csvContent = [headers, ...rows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const dateStamp = new Date().toISOString().slice(0, 10);
        link.href = url;
        link.download = `manage-parents-${dateStamp}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const clearAllFilters = () => {
        setAssignedAdminFilter("");
        setPastCompletedFilter("");
        setActiveChildFilter("");
        setAiAccessFilter("");
        setSubscriptionStatusFilter("");
        setCountryFilter("");
        setStateFilter("");
        setLeadSourceFilter("");
        setActiveCohortFilter("");
        setPreviouslySubscribedFilter("");
        setDndFilter("");
        setSmsOptOutFilter("");
        setEmailOptOutFilter("");
        setSearchQuery("");
        setCurrentPage(1);
        setFilterResetKey((prev) => prev + 1);
        setListNonce((prev) => prev + 1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (size) => {
        if (size === 'all') {
            setShowAll(true);
            setPageSize(10000);
        } else {
            setShowAll(false);
            setPageSize(parseInt(size));
            setCurrentPage(1);
        }
    };

    const goToNextPage = () => {
        if (pagination.hasNextPage) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (pagination.hasPreviousPage) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSingleSendEmail = (userId) => {
        setSelectedUserId(userId);
        toggleSingle();
    };

    const freeCohortModal = (parent) => {
        setSelectedParent(parent);
        togglek();
    };


    const onClickDelete = (userData) => {
        setContact(userData);
        setDeleteModal(true);
    };

    const onClickResetPassword = async (userData) => {
        //set new password for parent
        let _newPass = prompt("Enter new password for " + userData?.firstName + " " + userData?.lastName + ". Warning: This action cannot be undo");
        if (_newPass) {
            //reset parent password
            await axios.post(`${baseUrl}/admin/parent/reset-password/${userData.id}`, {
                newPassword: _newPass,
            });
            //parent password altered
            toast.success("Parent password altered !")
        }
    };

    const onClickUpdateParentDetails = async (userData) => {
        const selectedCountry = (Array.isArray(country) ? country : []).find(
            (c) => String(c?.name || "").toLowerCase() === String(userData?.country || "").toLowerCase()
        );
        setState(Array.isArray(selectedCountry?.states) ? selectedCountry.states : []);
        setTimezone(Array.isArray(selectedCountry?.timezones) ? selectedCountry.timezones : []);
        setUpdateParentForm({
            id: userData?.id ?? null,
            firstName: userData?.firstName || "",
            lastName: userData?.lastName || "",
            email: userData?.email || "",
            phone: userData?.phone || "",
            country: userData?.country || "",
            state: userData?.state || "",
            timezone: userData?.timezone || "",
        });
        setUpdateParentModal(true);
    };

    const handleUpdateCountryChange = (countryName) => {
        const selectedCountry = (Array.isArray(country) ? country : []).find(
            (c) => c?.name === countryName
        );
        const nextStates = Array.isArray(selectedCountry?.states) ? selectedCountry.states : [];
        const nextTimezones = Array.isArray(selectedCountry?.timezones) ? selectedCountry.timezones : [];
        const currentStateExists = nextStates.some((s) => s?.name === updateParentForm.state);
        const currentTimezoneExists = nextTimezones.some((t) => t?.zoneName === updateParentForm.timezone);

        setState(nextStates);
        setTimezone(nextTimezones);
        setUpdateParentForm((prev) => ({
            ...prev,
            country: countryName,
            state: currentStateExists ? prev.state : (nextStates[0]?.name || ""),
            timezone: currentTimezoneExists ? prev.timezone : (nextTimezones[0]?.zoneName || ""),
            phone: normalizePhoneWithCountryCode(prev.phone, selectedCountry?.phone_code),
        }));
    };

    const handleUpdateParentField = (key, value) => {
        setUpdateParentForm((prev) => ({ ...prev, [key]: value }));
    };

    const submitUpdateParentDetails = async () => {
        if (!updateParentForm?.id) return;
        try {
            setUpdatingParent(true);
            await axios.put(`${baseUrl}/admin/parent/edit/${updateParentForm.id}`, {
                firstName: String(updateParentForm.firstName || "").trim(),
                lastName: String(updateParentForm.lastName || "").trim(),
                email: String(updateParentForm.email || "").trim(),
                phone: String(updateParentForm.phone || "").trim(),
                country: String(updateParentForm.country || "").trim(),
                state: String(updateParentForm.state || "").trim(),
                timezone: String(updateParentForm.timezone || "").trim() || null,
            });
            toast.success("Parent details updated successfully");
            setUpdateParentModal(false);
            await fetchUsers();
        } catch (error) {
            handleAuthError(error);
            toast.error(error?.response?.data?.message || "Failed to update parent details");
        } finally {
            setUpdatingParent(false);
        }
    };

    const handleDeleteUser = async () => {
        try {
            await axios.delete(`${baseUrl}/admin/parent/${contact.id}`);
            const updatedUsers = users.filter((user) => user.id !== contact.id);
            setUsers(updatedUsers);
            setDeleteModal(false);
            toast.success("Parent deleted successfully");
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
            toast.error("Failed to delete parent");
        }
    };

    //filter mode
    const performFilter = (n) => {
        if (n === 2) {
            const __filter = [...usersRawF].filter((x => x.privacyMode === false))
            setUsers(applyParentTableFilters(__filter))
        }
        if (n === 1) {
            const __filter = [...usersRawF].filter((x => x.privacyMode === true))
            setUsers(applyParentTableFilters(__filter))
        }
        if (n === 0) {
            setUsers(applyParentTableFilters(usersRawF || []))
        }
    }

    const performExtenalFilter = (n) => {
        if (n === 1) {
            const __filter = [...usersRawF].filter((x => x.isExternal === 1))
            setUsers(applyParentTableFilters(__filter))
        }
        if (n === 0) {
            setUsers(applyParentTableFilters(usersRawF || []))
        }
    }

    const groupEmail = (t, e) => {
        SetGroupEmailData({ ...groupEmailData, [t]: e.target.value })
    }

    //resolve all child names for parents
    const getAllChildName = (pData) => {
        if (pData?.children?.length > 0) {
            //fetch child name
            return pData.children.map(((child) => ({
                childNames: `${child?.firstName} ${child?.lastName}`,
                isActive: (Array.isArray(child.programs) ? child.programs : []).some((y) =>
                    isActiveEnrollmentProgram(y)
                ),
            })))
        } else {
            return null
        }
    }


    const handleUserCredit = async (id) => {
        const confirmed = await showConfirm({ title: "Toggle wallet", message: "Are you sure you want to toggle user wallet?", variant: "primary" });
        if (confirmed) {
            const udp = {
                token: 'super+push-cmd',
                amount: balKey['key' + id] || 0
            }
            const dd = await axios.post(`${baseUrl}/admin/parent/credit/${id}`, udp);
            toast.info("User balance toggled successfully, reload to confirm");
            console.log(dd.data);
        }
    }

    const getReferredValue = (status) => {
        if (status === null) {
            return 'NO';
        } else {
            return 'YES';
        }
    };

    const getReferredColor = (status) => {
        if (status === null) {
            return 'danger';
        } else {
            return 'success';
        }
    };

    const getDndValue = (status) => {
        if (status === 0) {
            return 'OFF';
        } else {
            return 'ON';
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 0:
                return 'danger';
            case 1:
                return 'success';
        }
    };

    const toggleDnd = async (parentId) => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/dnd/${parentId}`);
            const updatedParents = response.data.data;
            const updated = users.map((b) => b.id === parentId ? { ...b, dnd: updatedParents.dnd } : b);
            setUsers(updated);
            toast.success("DND activated successfully");
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
            toast.error("Failed to update status");
        }
    };

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all items
            const allIDs = users.map(user => user.id);
            setMultiIDs(allIDs);
            toast.warn("All items have been added to the action list.");
        } else {
            setMultiIDs([])
            toast.error("All items have been removed from the action list.");
        }
    };

    const token = localStorage.getItem('token');

    const aiParentAppUrl = (
        process.env.REACT_APP_AI_TUTOR_ORIGIN ||
        process.env.REACT_APP_AI_CURRICULUM_PREVIEW_ORIGIN ||
        "https://ai.rydlearning.com"
    ).replace(/\/+$/, "");

    function buildAdminParentExploreUrl(parentId, appBaseUrl) {
        const payload = {
            adminToken: token,
            parentId,
            timestamp: Date.now(),
        };
        const code = toBase64Url(payload);
        return `${appBaseUrl}/auth/redirect?code=${encodeURIComponent(code)}`;
    }

    function openTacherogin(parentId) {
        // const url = "http://localhost:3002"
        const url = "https://parent.rydlearning.com";
        window.open(buildAdminParentExploreUrl(parentId, url), "_blank", "noopener,noreferrer");
    }

    function openAiParentLogin(parentId) {
        // const url = "http://localhost:5173"
        window.open(buildAdminParentExploreUrl(parentId, aiParentAppUrl), "_blank", "noopener,noreferrer");
    }

    const stateOptions = (() => {
        const countries = filterMeta.countries || [];
        if (countryFilter) {
            return countries.find((item) => item.name === countryFilter)?.states || [];
        }
        return [...new Set(countries.flatMap((item) => item.states || []))]
            .sort((a, b) => a.localeCompare(b));
    })();

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteUser}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem={`${isAiParentPage ? "Manage AI Parents" : "Manage Parent"}  (${users.length})`} />
                    {readOnly && isAiParentPage && (
                        <Row className="mb-2">
                            <Col>
                                <div className="alert alert-info mb-0 py-2">
                                    For the full parent list (all platform parents), open{" "}
                                    <Link to="/manage-parent">Manage Parent</Link>.
                                </div>
                            </Col>
                        </Row>
                    )}
                    {readOnly && !isAiParentPage && (
                        <Row className="mb-2">
                            <Col>
                                <div className="alert alert-secondary mb-0 py-2">
                                    Read-only view — search and filters only; actions are disabled.
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col lg="12">
                            <Row className="align-items-center">

                                <div className="parent-filter-panel mb-3">
                                        <div className="parent-filter-toolbar">
                                            <div className="parent-filter-search">
                                                <i className="mdi mdi-magnify" />
                                                <Input
                                                    type="text"
                                                    placeholder={isAiParentPage ? "Search name or email..." : "Search parent, email, or child..."}
                                                    value={searchQuery}
                                                    onChange={handleSearch}
                                                />
                                            </div>
                                            <div className="parent-filter-actions">
                                                <div className="parent-filter-actions-main">
                                                    <button
                                                        type="button"
                                                        className={`btn btn-light ${filtersOpen ? "active" : ""}`}
                                                        onClick={() => setFiltersOpen((open) => !open)}
                                                    >
                                                        <i className={`mdi mdi-chevron-${filtersOpen ? "up" : "down"}`}></i>
                                                        Filters
                                                    </button>
                                                    <button type="button" className="btn btn-light" onClick={clearAllFilters}>
                                                        <i className="mdi mdi-filter-remove-outline"></i> Clear
                                                    </button>
                                                    {!readOnly && (
                                                        <button type="button" className="btn btn-light" onClick={exportCurrentParents} disabled={!users?.length}>
                                                            <i className="mdi mdi-download"></i> Export
                                                        </button>
                                                    )}
                                                </div>
                                                {!isAiParentPage && !readOnly && (
                                                    <div className="parent-filter-actions-extra">
                                                        <button type="button" className="btn btn-light" onClick={() => toggle()}>
                                                            <i className="mdi mdi-email-variant"></i> Message all
                                                        </button>
                                                        <button type="button" className="btn btn-light" onClick={() => toggleAssignModal()} disabled={multiIDs.length === 0}>
                                                            <i className="mdi mdi-account-plus"></i> Assign
                                                        </button>
                                                        <Link to="/parent/inactive-program" className="btn btn-light">
                                                            <i className="mdi mdi-account"></i> Inactive programs
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <Collapse isOpen={filtersOpen}>
                                        <div className="parent-filter-groups">
                                            <section className="parent-filter-group">
                                                <h6>Location</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="Country">
                                                        <select className="form-control" value={countryFilter} onChange={(e) => handleCountryFilter(e.target.value)}>
                                                            <option value="">All</option>
                                                            {filterMeta.countries.map((item) => (
                                                                <option key={item.name} value={item.name}>{item.name}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="State">
                                                        <select className="form-control" value={stateFilter} onChange={(e) => applyServerFilter(setStateFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            {stateOptions.map((name) => (
                                                                <option key={name} value={name}>{name}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Lead source">
                                                        <select className="form-control" value={leadSourceFilter} onChange={(e) => applyServerFilter(setLeadSourceFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="__none__">Not set</option>
                                                            {filterMeta.leadSources.map((source) => (
                                                                <option key={source} value={source}>{source}</option>
                                                            ))}
                                                        </select>
                                                    </FilterField>
                                                </div>
                                            </section>

                                            {!isAiParentPage && (
                                                <section className="parent-filter-group">
                                                    <h6>Enrollment</h6>
                                                    <div className="parent-filter-grid">
                                                        <FilterField label="Past cohort completion">
                                                            <select className="form-control" value={pastCompletedFilter} onChange={(e) => applyServerFilter(setPastCompletedFilter)(e.target.value)}>
                                                                <option value="">All</option>
                                                                <option value="yes">Completed a past cohort</option>
                                                                <option value="no">Has not completed</option>
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Active cohort">
                                                            <select className="form-control" value={activeCohortFilter} onChange={(e) => applyServerFilter(setActiveCohortFilter)(e.target.value)}>
                                                                <option value="">All ongoing cohorts</option>
                                                                {filterMeta.activeCohorts.map((cohort) => (
                                                                    <option key={cohort.id} value={cohort.id}>{cohort.title}</option>
                                                                ))}
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Any active enrollment">
                                                            <select className="form-control" value={activeChildFilter} onChange={(e) => applyServerFilter(setActiveChildFilter)(e.target.value)}>
                                                                <option value="">All</option>
                                                                <option value="yes">In an ongoing cohort</option>
                                                                <option value="no">Not in an ongoing cohort</option>
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Assigned admin">
                                                            <select className="form-control" value={assignedAdminFilter} onChange={(e) => applyServerFilter(setAssignedAdminFilter)(e.target.value)}>
                                                                <option value="">All</option>
                                                                <option value="unassigned">Unassigned</option>
                                                                {admins.map((admin) => (
                                                                    <option key={admin.id} value={admin.id}>{admin.fullName}</option>
                                                                ))}
                                                            </select>
                                                        </FilterField>
                                                    </div>
                                                </section>
                                            )}

                                            <section className="parent-filter-group">
                                                <h6>AI</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="Previously subscribed to AI">
                                                        <select className="form-control" value={previouslySubscribedFilter} onChange={(e) => applyServerFilter(setPreviouslySubscribedFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="yes">Yes</option>
                                                            <option value="no">No</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Active in AI">
                                                        <select className="form-control" value={subscriptionStatusFilter} onChange={(e) => handleSubscriptionStatusFilter(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="yes">Active</option>
                                                            <option value="no">Not active</option>
                                                        </select>
                                                    </FilterField>
                                                    {!isAiParentPage && (
                                                        <FilterField label="AI access">
                                                            <select className="form-control" value={aiAccessFilter} onChange={(e) => handleAiAccessFilter(e.target.value)}>
                                                                <option value="">All</option>
                                                                <option value="yes">Has access</option>
                                                                <option value="no">No access</option>
                                                            </select>
                                                        </FilterField>
                                                    )}
                                                </div>
                                            </section>

                                            <section className="parent-filter-group">
                                                <h6>Communication</h6>
                                                <div className="parent-filter-grid">
                                                    <FilterField label="DND">
                                                        <select className="form-control" value={dndFilter} onChange={(e) => applyServerFilter(setDndFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="yes">On</option>
                                                            <option value="no">Off</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="SMS opt out">
                                                        <select className="form-control" value={smsOptOutFilter} onChange={(e) => applyServerFilter(setSmsOptOutFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="yes">Opted out</option>
                                                            <option value="no">Opted in</option>
                                                        </select>
                                                    </FilterField>
                                                    <FilterField label="Email opt out">
                                                        <select className="form-control" value={emailOptOutFilter} onChange={(e) => applyServerFilter(setEmailOptOutFilter)(e.target.value)}>
                                                            <option value="">All</option>
                                                            <option value="yes">Opted out</option>
                                                            <option value="no">Opted in</option>
                                                        </select>
                                                    </FilterField>
                                                </div>
                                            </section>

                                            {!isAiParentPage && (
                                                <section className="parent-filter-group parent-filter-group-wide">
                                                    <h6>More</h6>
                                                    <div className="parent-filter-grid">
                                                        <FilterField label="Cohort status">
                                                            <select
                                                                key={`parent-cohort-filter-${filterResetKey}`}
                                                                className="form-control"
                                                                onChange={async (e) => {
                                                                    const value = Number(e.target.value);
                                                                    if (value === 0) {
                                                                        await fetchUsers();
                                                                        return;
                                                                    }
                                                                    if (value === 4) {
                                                                        try {
                                                                            setLoading(true);
                                                                            const limit = showAll ? 10000 : pageSize;
                                                                            const response = await axios.get(`${baseUrl}/admin/parent/all`, {
                                                                                params: {
                                                                                    filter: "completedButInactive",
                                                                                    page: currentPage,
                                                                                    limit,
                                                                                    audience: "normal",
                                                                                    ...(searchQuery && { search: searchQuery }),
                                                                                },
                                                                            });
                                                                            const responseData = response.data.data;
                                                                            const data = responseData?.data || (Array.isArray(responseData) ? responseData : []);
                                                                            const paginationData = responseData?.pagination || {
                                                                                currentPage: 1,
                                                                                totalPages: 1,
                                                                                totalItems: Array.isArray(data) ? data.length : 0,
                                                                                itemsPerPage: limit,
                                                                                hasNextPage: false,
                                                                                hasPreviousPage: false,
                                                                            };
                                                                            setUsersRawF(data);
                                                                            setUsers(data);
                                                                            setPagination(paginationData);
                                                                            setLoading(false);
                                                                        } catch (error) {
                                                                            handleAuthError(error);
                                                                            setLoading(false);
                                                                            toast.error("Failed to fetch filtered parents");
                                                                        }
                                                                        return;
                                                                    }
                                                                    let __filter = usersRaw;
                                                                    if (value === 1) __filter = filterParentsByCohortMode(usersRaw, "active");
                                                                    else if (value === 2) __filter = filterParentsByCohortMode(usersRaw, "no-active");
                                                                    else if (value === 3) __filter = filterParentsByCohortMode(usersRaw, "alumni");
                                                                    setUsersRawF(__filter);
                                                                    setUsers(__filter);
                                                                }}
                                                            >
                                                                <option value={0}>All parents</option>
                                                                <option value={1}>With active cohort</option>
                                                                <option value={2}>With no active cohort</option>
                                                                <option value={3}>All alumni</option>
                                                                <option value={4}>Completed but inactive</option>
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Program completion">
                                                            <select
                                                                key={`completion-filter-${filterResetKey}`}
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    const filterType = Number(e.target.value);
                                                                    if (filterType === 0) {
                                                                        setUsersRawF(usersRaw);
                                                                        setUsers(usersRaw);
                                                                        return;
                                                                    }
                                                                    const filtered = usersRaw.filter((parent) => {
                                                                        const hasCompleted = parent?.children?.some((child) =>
                                                                            child?.programs?.some((program) => program?.isCompleted === true)
                                                                        );
                                                                        return filterType === 1 ? hasCompleted : !hasCompleted;
                                                                    });
                                                                    setUsersRawF(filtered);
                                                                    setUsers(filtered);
                                                                }}
                                                            >
                                                                <option value={0}>All</option>
                                                                <option value={1}>With completed programs</option>
                                                                <option value={2}>Without completed programs</option>
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Referrals">
                                                            <select
                                                                key={`referral-filter-${filterResetKey}`}
                                                                className="form-control"
                                                                onChange={(e) => {
                                                                    const status = Number(e.target.value);
                                                                    let filtered = usersRaw;
                                                                    if (status === 1) filtered = usersRaw.filter((r) => r.referredBy === null);
                                                                    else if (status === 2) filtered = usersRaw.filter((r) => r.referredBy !== null);
                                                                    setUsersRawF(filtered);
                                                                    setUsers(filtered);
                                                                }}
                                                            >
                                                                <option value={0}>All</option>
                                                                <option value={1}>Normal parents</option>
                                                                <option value={2}>Referred parents</option>
                                                            </select>
                                                        </FilterField>
                                                        <FilterField label="Parent type">
                                                            <select key={`external-filter-${filterResetKey}`} className="form-control" onChange={(e) => performExtenalFilter(Number(e.target.value))}>
                                                                <option value={0}>All</option>
                                                                <option value={1}>Promo parent</option>
                                                            </select>
                                                        </FilterField>
                                                    </div>
                                                </section>
                                            )}
                                        </div>
                                        </Collapse>
                                </div>

                                {!isAiParentPage && (
                                <p>
                                    Privacy
                                    Mode: {privateParentOnly === 0 ? "All Mode" : privateParentOnly === 1 ? "Private" : "Public"}
                                </p>
                                )}
                            </Row>
                            <Row>
                                <Col xl="12" className={'divTable'}>
                                    {loading ? (
                                        <div className="text-center mt-5">
                                            <div
                                                className="spinner-border text-primary"
                                                role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : users.length === 0 ? (
                                        <div className="text-center mt-5">
                                            <h3>No data available</h3>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                        <table className="table table-hover align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>
                                                        {isAiParentPage || readOnly ? (
                                                            <span className="text-muted">#</span>
                                                        ) : (
                                                        <div style={{ width: 50 }} className={'align-middle'}>
                                                            <input
                                                                style={{ marginRight: 5 }}
                                                                type={'checkbox'}
                                                                onChange={e => handleSelectAllChange(e)}
                                                            />
                                                            All
                                                        </div>
                                                        )}
                                                    </th>
                                                    <th>Parent Name</th>
                                                    {!isAiParentPage && <th>Children Name(s)</th>}
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>State</th>
                                                    <th>Lead Source</th>
                                                    {/*<th>Data Privacy</th>*/}
                                                    <th>Country</th>
                                                    <th>Timezone</th>
                                                    {!isAiParentPage && <th>Balance</th>}
                                                    {!isAiParentPage && <th>No.Child</th>}
                                                    {!isAiParentPage && <th>Free_Cohort</th>}
                                                    {!isAiParentPage && <th>DND</th>}
                                                    {!isAiParentPage && <th>SMS Opt-Out</th>}
                                                    {!isAiParentPage && <th>Email Opt-Out</th>}
                                                    <th>AI access</th>
                                                    <th>Subscription status</th>
                                                    <th>Subscribed date</th>
                                                    {isAiParentPage && <th>Subscription cancellation date</th>}
                                                    {isAiParentPage && <th>Previously subscribed to AI</th>}
                                                    {!isAiParentPage && <th>Clicked subscribe</th>}
                                                    <th>Emails sent</th>
                                                    {!isAiParentPage && <th>Past Cohort Completion</th>}
                                                    {!isAiParentPage && <th>Active Child Enrollment</th>}
                                                    {!isAiParentPage && <th>Children Current Levels</th>}
                                                    {!isAiParentPage && <th>Assigned_to</th>}
                                                    {!isAiParentPage && <th>Referred</th>}
                                                    {!isAiParentPage && <th>Total_Referred</th>}
                                                    <th>Created_At</th>
                                                    {!readOnly && <th>Action</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(users) &&
                                                    users.map((user, index) => {
                                                        const globalIndex = showAll 
                                                            ? index 
                                                            : (pagination.currentPage - 1) * pagination.itemsPerPage + index;
                                                        const parentInsights = getParentProgramInsights(user);
                                                        return (
                                                            <tr key={user.id || index}
                                                                style={{ backgroundColor: user?.privacyMode ? '#ffeff2' : '#fff' }}>
                                                                <td>
                                                                    <div style={{ width: 50 }} className={'align-middle'}>
                                                                        {!isAiParentPage && !readOnly && (
                                                                        <input style={{ marginRight: 5 }} type={'checkbox'} checked={multiIDs.includes(user.id)}
                                                                            onClick={(d) => {
                                                                                //multiple selection push to array
                                                                                if (multiIDs.includes(user.id)) {
                                                                                    //remove from array
                                                                                    setMultiIDs(multiIDs.filter(i => i !== user.id))
                                                                                    toast.error(user?.firstName + " removed is been from the action list.")
                                                                                } else {
                                                                                    setMultiIDs([...multiIDs, user.id])
                                                                                    toast.warn(user?.firstName + " has been added to action list.")
                                                                                }
                                                                            }} />
                                                                        )}
                                                                        {globalIndex + 1}
                                                                    </div>
                                                                </td>
                                                                <td>{user.firstName} {user.lastName}</td>
                                                                {!isAiParentPage && <td style={{ width: 200 }}>
                                                                    <div
                                                                        style={{ whiteSpace: 'nowrap' }}>{(user?.children?.length > 0 && getAllChildName(user).map((x, i) =>
                                                                            <li style={{ fontWeight: !x.isActive ? 'normal' : 'bold' }}
                                                                                key={i}>{x.childNames}</li>)) ||
                                                                            <li>No Child</li>}</div>
                                                                </td>}
                                                                <td>{user.email}</td>
                                                                <td>{user.phone}</td>
                                                                <td style={{ width: 20 }}>{user.state}</td>
                                                                <td>{user.survey || "—"}</td>
                                                                {/*<td>{user.privacyMode ? "Private" : "Not Private"}</td>*/}
                                                                <td>{user.country}</td>
                                                                <td>{user.timezone}</td>
                                                                {!isAiParentPage && <td>
                                                                    {readOnly ? (
                                                                        <span>{user?.balance}</span>
                                                                    ) : (
                                                                    <>
                                                                    {currency_country[user?.country]}
                                                                    <input
                                                                        readOnly={!balKeyEdit['key' + user.id]}
                                                                        multiple={false}
                                                                        type={'number'}
                                                                        defaultValue={user?.balance}
                                                                        value={balKey['key' + user.id]}
                                                                        style={{ borderWidth: 0, width: 80 }}
                                                                        onChange={e => setBalanceKey({ ['key' + user.id]: e.target.value })} />
                                                                    <Link
                                                                        style={{ display: !balKeyEdit['key' + user.id] ? 'none' : '' }}
                                                                        className="text-primary"
                                                                        to="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleUserCredit(user.id);
                                                                        }}>
                                                                        <i className="mdi mdi-check font-size-18"></i>
                                                                    </Link>
                                                                    </>
                                                                    )}
                                                                </td>}
                                                                {!isAiParentPage && <td>{user?.children?.length}</td>}
                                                                {!isAiParentPage && <td>{user?.freeCohort}</td>}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={getStatusColor(user.dnd)}>
                                                                        {getDndValue(user.dnd)}
                                                                    </StatusBadge>
                                                                </td>}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={user?.smsOptOut ? 'warning' : 'success'}>
                                                                        {user?.smsOptOut ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={user?.emailOptOut ? 'warning' : 'success'}>
                                                                        {user?.emailOptOut ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>}
                                                                <td>
                                                                    <StatusBadge variant={user?.canAccessAi ? 'success' : 'danger'}>
                                                                        {user?.canAccessAi ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>
                                                                <td>
                                                                    <StatusBadge variant={user?.isSubscribed ? 'success' : 'danger'}>
                                                                        {user?.isSubscribed ? "Active" : "Inactive"}
                                                                    </StatusBadge>
                                                                </td>
                                                                <td>
                                                                    {user?.aiSubscribedAt
                                                                        ? newFormatDate(user.aiSubscribedAt)
                                                                        : "—"}
                                                                </td>
                                                                {isAiParentPage && (
                                                                    <td>
                                                                        {user?.aiCanceledAt
                                                                            ? newFormatDate(user.aiCanceledAt)
                                                                            : "—"}
                                                                    </td>
                                                                )}
                                                                {isAiParentPage && (
                                                                    <td>
                                                                        <StatusBadge variant={user?.previouslySubscribedToAi ? "success" : "danger"}>
                                                                            {user?.previouslySubscribedToAi ? "Yes" : "No"}
                                                                        </StatusBadge>
                                                                    </td>
                                                                )}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={user?.clickedAiTutorSubscribeIntent ? 'success' : 'danger'}>
                                                                        {user?.clickedAiTutorSubscribeIntent ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>}
                                                                <td style={{ minWidth: 140 }}>
                                                                    {(() => {
                                                                        const sent = getAiAbandonEmailsSent(user);
                                                                        if (!sent.length) return "—";
                                                                        return (
                                                                            <div className="d-flex flex-wrap gap-1">
                                                                                {sent.map((label) => (
                                                                                    <StatusBadge key={label} variant="success">
                                                                                        {label}
                                                                                    </StatusBadge>
                                                                                ))}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </td>
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={parentInsights.hasCompletedPastCohort ? 'success' : 'danger'}>
                                                                        {parentInsights.hasCompletedPastCohort ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={parentInsights.hasActiveChildEnrollment ? 'success' : 'danger'}>
                                                                        {parentInsights.hasActiveChildEnrollment ? "Yes" : "No"}
                                                                    </StatusBadge>
                                                                </td>}
                                                                {!isAiParentPage && <td style={{ minWidth: 220 }}>{parentInsights.childLevelSummary}</td>}
                                                                {!isAiParentPage && <td>{user?.assignedTo ? user?.admin?.fullName : "Unassigned"}</td>}
                                                                {!isAiParentPage && <td>
                                                                    <StatusBadge variant={getReferredColor(user.referredBy)}>
                                                                        {getReferredValue(user.referredBy)}
                                                                    </StatusBadge>
                                                                </td>}
                                                                {!isAiParentPage && <td>{user?.totalReferred}</td>}
                                                                <td>{newFormatDate(user.createdAt)}</td>
                                                                {!readOnly && (
                                                                <td>
                                                                    <ActionsDropdown
                                                                        loading={actionLoadingId === user.id}
                                                                        toggleTitle="Parent actions"
                                                                        items={isAiParentPage ? [
                                                                            { label: "Update parent details", icon: "mdi-account-edit-outline", onClick: () => onClickUpdateParentDetails(user), variant: "warning" },
                                                                            { label: "Send email", icon: "mdi-email-variant", onClick: () => handleSingleSendEmail(user.id), variant: "primary" },
                                                                            { label: "Reset password", icon: "mdi-key", onClick: async () => { setActionLoadingId(user.id); try { await onClickResetPassword(user); } finally { setActionLoadingId(null); } }, variant: "danger" },
                                                                            { label: "Add note", icon: "mdi-note-plus", onClick: () => toggleNoteModal(user), variant: "info" },
                                                                            { label: "Explore account", icon: "mdi-open-in-new", onClick: () => showConfirm({ title: "Explore account", message: "Do you really want to explore " + (user?.firstName || "") + " " + (user?.lastName || "") + "'s AI account?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(user.id); try { openAiParentLogin(user.id); } finally { setActionLoadingId(null); } } }), variant: "success" },
                                                                            { label: "Activate AI by transfer", icon: "mdi-bank-transfer", onClick: () => openActivateTransferModal(user), variant: "success" },
                                                                            { divider: true },
                                                                            { label: "Cancel AI subscription (end of period)", icon: "mdi-calendar-clock", onClick: () => showConfirm({ title: "Cancel at period end", message: `Schedule cancellation for ${user?.firstName || ""} ${user?.lastName || ""}? They keep access until the current billing period ends.`, variant: "primary" }).then(async (ok) => { if (ok) await adminCancelAiParentSubscription(user, false); }), variant: "warning" },
                                                                            { label: "Cancel AI subscription immediately", icon: "mdi-close-octagon-outline", onClick: () => showConfirm({ title: "Cancel immediately", message: `Cancel ${user?.firstName || ""} ${user?.lastName || ""}'s subscription now? They lose paid access right away.`, variant: "danger" }).then(async (ok) => { if (ok) await adminCancelAiParentSubscription(user, true); }), variant: "danger" },
                                                                            { label: "Upgrade to Normal Parent", icon: "mdi-arrow-up-bold-circle-outline", onClick: () => showConfirm({ title: "Upgrade parent", message: `Upgrade ${user?.firstName || ""} ${user?.lastName || ""} to normal parent access?`, variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(user.id); try { await axios.put(`${baseUrl}/admin/parent/upgrade-ai/${user.id}`); toast.success("Parent upgraded successfully"); await fetchUsers(); } finally { setActionLoadingId(null); } } }), variant: "success" },
                                                                        ] : [
                                                                            { label: "Enable credit edit", icon: "mdi-wallet-plus", onClick: () => setBalKeyEdit({ ['key' + user.id]: !balKeyEdit['key' + user.id] }), variant: "primary" },
                                                                            { label: "Update parent details", icon: "mdi-account-edit-outline", onClick: () => onClickUpdateParentDetails(user), variant: "warning" },
                                                                            { label: "Send email", icon: "mdi-email-variant", onClick: () => handleSingleSendEmail(user.id), variant: "primary" },
                                                                            { label: "Reset password", icon: "mdi-key", onClick: async () => { setActionLoadingId(user.id); try { await onClickResetPassword(user); } finally { setActionLoadingId(null); } }, variant: "danger" },
                                                                            { label: "Add note", icon: "mdi-note-plus", onClick: () => toggleNoteModal(user), variant: "info" },
                                                                            { label: "Activate AI by transfer", icon: "mdi-bank-transfer", onClick: () => openActivateTransferModal(user), variant: "success" },
                                                                            { label: "Assign free cohort", icon: "mdi-gift", onClick: () => freeCohortModal(user), variant: "info" },
                                                                            { divider: true },
                                                                            { label: "Assign to admin", icon: "mdi-account-arrow-right", onClick: () => toggleAssignModal(user), variant: "warning" },
                                                                            { label: "View referred parents", icon: "mdi-eye", onClick: () => toggleParentsModal(user), variant: "primary" },
                                                                            { label: `Toggle DND (${getDndValue(user.dnd)})`, icon: "mdi-do-not-disturb", onClick: () => showConfirm({ title: "Toggle DND", message: "Are you sure you want to Deactivate/Activate DND for this parent?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(user.id); try { await toggleDnd(user.id); } finally { setActionLoadingId(null); } } }), variant: "info" },
                                                                            { divider: true },
                                                                            { label: "Explore account", icon: "mdi-open-in-new", onClick: () => showConfirm({ title: "Explore account", message: "Do you really want to explore " + (user?.firstName || "") + " " + (user?.lastName || "") + "'s account?", variant: "primary" }).then(async (ok) => { if (ok) { setActionLoadingId(user.id); try { await openTacherogin(user.id); } finally { setActionLoadingId(null); } } }), variant: "success" },
                                                                        ]}
                                                                    />
                                                                </td>
                                                                )}
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                        </div>
                                    )}
                                    {Array.isArray(users) && users.length > 0 && (
                                        <PaginationControls
                                            currentPage={pagination.currentPage}
                                            totalPages={pagination.totalPages}
                                            totalItems={pagination.totalItems}
                                            pageSize={pagination.itemsPerPage}
                                            showAll={showAll}
                                            handlePageChange={handlePageChange}
                                            handlePageSizeChange={handlePageSizeChange}
                                            goToNextPage={goToNextPage}
                                            goToPreviousPage={goToPreviousPage}
                                            canPreviousPage={pagination.hasPreviousPage}
                                            canNextPage={pagination.hasNextPage}
                                            paginatedDataLength={users.length}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ActivateAiTransferModal
                isOpen={activateTransferModal}
                toggle={() => {
                    if (actionLoadingId) return;
                    setActivateTransferModal(!activateTransferModal);
                    if (activateTransferModal) setActivateTransferParent(null);
                }}
                parentLabel={
                    activateTransferParent
                        ? `${activateTransferParent.firstName || ""} ${activateTransferParent.lastName || ""}`.trim()
                        : ""
                }
                loading={
                    !!activateTransferParent &&
                    actionLoadingId === activateTransferParent.id
                }
                onSubmit={activateAiByTransfer}
            />
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Compose Email</ModalHeader>
                <ModalBody>
                    <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className={'mb-3'}>
                                    <Label className="form-label">Email Target</Label>
                                    <select value={groupEmailData.t} className={'form-control'}
                                        onChange={(e) => groupEmail("t", e)}>
                                        <option value={0}>With All Cohort Status</option>
                                        <option value={1}>With Active Cohort</option>
                                        <option value={2}>With No Active Cohort</option>
                                        <option value={3}>With Idle Cohort</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Subject</Label>
                                    <Input
                                        name="subject"
                                        type="text"
                                        placeholder="Subject"
                                        onChange={(e) => groupEmail("s", e)}
                                        value={groupEmailData.s}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Body</Label>
                                    <EditorProvider>
                                        <Editor value={groupEmailData.b} onChange={(e) => groupEmail("b", e)}
                                            containerProps={{ style: { resize: 'vertical', height: 200 } }}>
                                            <Toolbar>
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnLink />
                                                <BtnBulletList />
                                                <BtnClearFormatting />
                                                <BtnNumberedList />
                                                <BtnStyles />
                                                <BtnUndo />
                                                <BtnRedo />
                                                <BtnStrikeThrough />
                                                <BtnUnderline />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                    <UploadWidget onUpload={handleOnUpload}>
                                        {({ open }) => {
                                            function handleOnClick(e) {
                                                e.preventDefault();
                                                open();
                                            }

                                            return (
                                                <a style={{ marginTop: 5 }} href={'#'} onClick={handleOnClick}>
                                                    {(url) ? "Override attachment" : "Add attachment"}
                                                </a>
                                            )
                                        }}
                                    </UploadWidget>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={toggle}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="ms-2 btn btn-primary ml-2"
                                        onClick={handleSendEmailAll}>
                                        Send Email
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            <Modal isOpen={updateParentModal} toggle={toggleUpdateParentModal}>
                <ModalHeader toggle={toggleUpdateParentModal}>Update Parent Details</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">First Name</Label>
                            <Input
                                type="text"
                                value={updateParentForm.firstName}
                                onChange={(e) => handleUpdateParentField("firstName", e.target.value)}
                            />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">Last Name</Label>
                            <Input
                                type="text"
                                value={updateParentForm.lastName}
                                onChange={(e) => handleUpdateParentField("lastName", e.target.value)}
                            />
                        </Col>
                        <Col md={12} className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                                type="email"
                                value={updateParentForm.email}
                                onChange={(e) => handleUpdateParentField("email", e.target.value)}
                            />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">Phone</Label>
                            <Input
                                type="text"
                                value={updateParentForm.phone}
                                onChange={(e) => handleUpdateParentField("phone", e.target.value)}
                                onBlur={() => {
                                    const selectedCountry = (Array.isArray(country) ? country : []).find(
                                        (c) => c?.name === updateParentForm.country
                                    );
                                    setUpdateParentForm((prev) => ({
                                        ...prev,
                                        phone: normalizePhoneWithCountryCode(prev.phone, selectedCountry?.phone_code),
                                    }));
                                }}
                            />
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">Country</Label>
                            <Input type="select" value={updateParentForm.country} onChange={(e) => handleUpdateCountryChange(e.target.value)}>
                                <option value="">Select country</option>
                                {(Array.isArray(country) ? country : []).map((item) => (
                                    <option key={item?.name} value={item?.name}>
                                        {item?.name}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">State</Label>
                            <Input type="select" value={updateParentForm.state} onChange={(e) => handleUpdateParentField("state", e.target.value)}>
                                <option value="">Select state</option>
                                {(Array.isArray(state) ? state : []).map((item) => (
                                    <option key={item?.id || item?.state_code || item?.name} value={item?.name}>
                                        {item?.name}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                        <Col md={6} className="mb-3">
                            <Label className="form-label">Timezone</Label>
                            <Input type="select" value={updateParentForm.timezone} onChange={(e) => handleUpdateParentField("timezone", e.target.value)}>
                                <option value="">Select timezone</option>
                                {(Array.isArray(timezone) ? timezone : []).map((item) => (
                                    <option key={item?.zoneName || item?.abbreviation || String(item)} value={item?.zoneName || ""}>
                                        {item?.zoneName || ""}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <div className="text-end">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggleUpdateParentModal}
                            disabled={updatingParent}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="ms-2 btn btn-primary"
                            onClick={submitUpdateParentDetails}
                            disabled={updatingParent}
                        >
                            {updatingParent ? "Updating..." : "Update Parent"}
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalk} toggle={togglek}>
                <ModalHeader toggle={togglek}>Assign free cohort</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs={12}>
                            <div className="mb-3">
                                <Label className="form-label">Cohort</Label>
                                <Input
                                    name="free cohort"
                                    type="number"
                                    placeholder="0"
                                    onChange={(e) => setFreeCohort(e.target.value)}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={togglek}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="ms-2 btn btn-primary ml-2"
                                    onClick={handleFreeCohort}>
                                    Assign cohort
                                </button>
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
            <Modal isOpen={noteModal} toggle={toggleNoteModal} size="lg">
                <ModalHeader toggle={toggleNoteModal}>
                    Notes for {selectedParent?.firstName} {selectedParent?.lastName}
                </ModalHeader>
                <ModalBody>
                    <div className="notes-container">
                        {parentNotes.length > 0 ? (
                            <div className="notes-list mb-4">
                                {parentNotes.map((note, index) => (
                                    <div key={index} className="note-card mb-3 p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="note-admin">
                                                <i className="mdi mdi-account-circle me-2"></i>
                                                {note.admin?.fullName}
                                            </div>
                                            <div className="note-date text-muted">
                                                {newFormatDate(note.createdAt)}
                                            </div>
                                        </div>
                                        <div className="note-content p-2">
                                            {note.note}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted">
                                No notes yet for this parent
                            </div>
                        )}

                        <div className="add-note-section">
                            <h5 className="mb-3">Add New Note</h5>
                            <EditorProvider>
                                <Editor
                                    value={newNote}
                                    onChange={(e) => setNewNote(e.target.value)}
                                    containerProps={{ style: { resize: 'vertical', height: 150 } }}
                                >
                                    <Toolbar>
                                        <BtnBold />
                                        <BtnItalic />
                                        <BtnLink />
                                        <BtnBulletList />
                                        <BtnClearFormatting />
                                        <BtnNumberedList />
                                        <BtnUndo />
                                        <BtnRedo />
                                    </Toolbar>
                                </Editor>
                            </EditorProvider>
                            <div className="text-end mt-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={() => {
                                        setNewNote("");
                                        toggleNoteModal();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAddNote}
                                >
                                    Save Note
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={assignModal} toggle={toggleAssignModal}>
                <ModalHeader toggle={toggleAssignModal}>
                    {multiIDs.length > 0 ? `Assign ${multiIDs.length} Parents` : `Assign ${selectedParent?.firstName} ${selectedParent?.lastName}`}
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <Label className="form-label">Select Admin</Label>
                        <select
                            className="form-control filter-control"
                            onChange={(e) => {
                                const adminId = e.target.value;
                                setSelectedAdmin(adminId);
                                console.log(adminId)
                            }}
                        >
                            <option value="">Select an admin</option>
                            {admins.map(admin => (
                                <option key={admin.id} value={admin.id}>
                                    {admin.fullName}
                                </option>
                            ))}
                        </select>

                        <div className={'align-middle my-3'}>
                            <input
                                style={{ marginRight: 5 }}
                                type={'checkbox'}
                                onChange={e => setSecondary(true)}
                            />
                            As Secondary
                        </div>
                    </div>
                    <div className="text-end mt-4">
                        <button
                            type="button"
                            className="btn btn-secondary me-2"
                            onClick={toggleAssignModal}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAssignParent}
                            disabled={!selectedAdmin}
                        >
                            Assign
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={referedModal} toggle={toggleParentsModal} size="lg">
                <ModalHeader toggle={toggleParentsModal}>
                    <i className="mdi mdi-account-multiple me-2"></i>
                    Parents List ({referedParents.length})
                </ModalHeader>
                <ModalBody>
                    {referedParents.length > 0 ? <div className="table-responsive">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Contact</th>
                                    <th>Location</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {referedParents.map((parent) => (
                                    <tr key={parent.id}>
                                        <td>
                                            <strong>{parent.firstName} {parent.lastName}</strong>
                                        </td>
                                        <td>
                                            <div>{parent.email}</div>
                                            <small className="text-muted">{parent.phone}</small>
                                        </td>
                                        <td>
                                            {parent.country}, {parent.state}
                                            <div>
                                                <small className="text-muted">
                                                    {parent.timezone} (UTC{parent.timeOffset >= 0 ? '+' : ''}{parent.timeOffset})
                                                </small>
                                            </div>
                                        </td>
                                        <td>
                                            <span className={`badge ${parent.status ? 'bg-success' : 'bg-secondary'}`}>
                                                {parent.status ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            {newFormatDate(parent.createdAt)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> : <span>This parent haven't refered any parents yet</span>}
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-between w-100">
                        <div>
                            Showing {referedParents.length} parents
                        </div>
                        <button className="btn btn-primary" onClick={toggleParentsModal}>
                            Close
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalSingle} toggle={toggleSingle}>
                <ModalHeader toggle={toggleSingle}>Compose Email</ModalHeader>
                <ModalBody>
                    <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className="mb-3">
                                    <Label className="form-label">Email Subject</Label>
                                    <Input
                                        name="subject"
                                        type="text"
                                        placeholder="Subject"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.subject}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Body</Label>
                                    <EditorProvider>
                                        <Editor name="message" onChange={validation.handleChange}
                                            value={validation.values.message}
                                            containerProps={{ style: { resize: 'vertical', height: 200 } }}>
                                            <Toolbar>
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnLink />
                                                <BtnBulletList />
                                                <BtnClearFormatting />
                                                <BtnNumberedList />
                                                <BtnStyles />
                                                <BtnUndo />
                                                <BtnRedo />
                                                <BtnStrikeThrough />
                                                <BtnUnderline />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                    <UploadWidget onUpload={handleOnUpload}>
                                        {({ open }) => {
                                            function handleOnClick(e) {
                                                e.preventDefault();
                                                open();
                                            }

                                            return (
                                                <a style={{ marginTop: 5 }} href={'#'} onClick={handleOnClick}>
                                                    {(url) ? "Override attachment" : "Add attachment"}
                                                </a>
                                            )
                                        }}
                                    </UploadWidget>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={toggleSingle}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="ms-2 btn btn-primary ml-2"
                                        onClick={handleSendEmailSingle}>
                                        Send Email
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            <ToastContainer />
        </React.Fragment>
    );
};
export default withAuth(ManageParent);
